<template>
      <card>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :staticFilters="staticFilters"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :filters="filters"
          :searchDisable="true"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
             filters: [
    
      ],
          staticFilters: [
    
        
        ],
      val: [],
      modalCreate: "navigation",
      fields: [
       {
        col:' col-12 col-md-12',
        key: "title",
        label: "Наименование",
        type: "field",
        textType: "text",
        isMultiLang:true
      },
      {
        col:' col-12 col-md-12',
        key: "code",
        label: "Код",
        type: "field",
        textType: "text",
      },
          {
          col:' col-12 col-md-12',
          key: "platform",
          label: "Платформа",
          type: "static_radio",
          items: [
              { id: 'web', title: "Веб-админ" },
              { id: 'app', title: "Приложение" },
              { id: 'business', title: "Бизнес приложение" },
          ],
      },
      {
        col:' col-12 col-md-12',
        key: "icon",
        label: "Иконка",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "type",
        label: "Type",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "alphaClr",
        label: "alphaClr",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "value",
        label: "Value",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "color",
        label: "Color",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "Component",
        label: "component",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "activeIcon",
        label: "activeIcons",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "position",
        label: "Position",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-12',
        key: "blocks",
        label: "Блоки (Дилерское приложение)",
        type: "selects",
        modal: "block",
        selectKey: "code",
      },
      {
        col:' col-12 col-md-12',
        key: "roles",
        label: "Для ролей",
        type: "selects",
        modal: "role",
        selectKey: "title",
      },
    
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_navigation",
      itemLink: "navigations",
      setLink: "navigations",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,

        },
        {
          key: "title",
          title: "Название",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "code",
          title: "Код",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
    
        {
          key: "roles",
          title: "Роли",
          object:'title',

          disableLink: true,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "platform",
          title: "Платформа",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
      
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
